import { Trans } from 'react-i18next';

import { ATTENTION_COLOR, CrossCircleFill } from '@any-ui-react/core';

import { toast } from '@anyx/shared-ui';

export const showSubServiceErrorNotification = (serviceName: string) =>
  toast(
    <Trans
      ns="gql"
      i18nKey="gql.notification.error.subServiceError.description"
      values={{ subService: serviceName }}
    />,
    {
      id: serviceName,
      color: ATTENTION_COLOR.error,
      icon: <CrossCircleFill />,
      title: <Trans ns="gql" i18nKey="gql.notification.error.subServiceError.title" />,
    }
  );
